import { render, staticRenderFns } from "./UserProductForm.vue?vue&type=template&id=54517426&scoped=true"
import script from "./UserProductForm.vue?vue&type=script&setup=true&lang=js"
export * from "./UserProductForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UserProductForm.vue?vue&type=style&index=0&id=54517426&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54517426",
  null
  
)

export default component.exports